import { DELETE_DOWNLAOD, GET_DOWNLOAD, GET_ONE_DOWNLOAD, SET_DOWNLOAD, UPDATE_DOWNLOAD } from "./actionType";

export const setDownload = (download) => {
    return{
        type: SET_DOWNLOAD,
        payload : download,
    };
};

export const getDownload = (downloadData) => {
    return{
        type: GET_DOWNLOAD,
        payload : downloadData,
    };
};

export const deleteDownload = (id) => {
    return {
        type: DELETE_DOWNLAOD,
        payload: id,
    }
}

export const updateDownloadData = (updatedDownload) => {
    return {
        type: UPDATE_DOWNLOAD,
        payload: updatedDownload,
    }
};

export const getOneDownload = (downloadOneData) => {
    return{
        type: GET_ONE_DOWNLOAD,
        payload: downloadOneData,
    }
};